<template>
  <a-card>
    <div class="mb15">
      <a-button type="primary" v-has:genCodeOrderCreate="showCreate">
        <PlusOutlined />
        创建生码单
      </a-button>
    </div>
    <a-form :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="品牌商" name='brand_id'>
        <a-select v-model:value="search.brand_id" show-search allowClear option-filter-prop="label" :style="{width:'220px'}" placeholder="全部">
          <a-select-option v-for="item in brands" :key="item.brand_no" :value="item.brand_no" :label="item.company + '(' + item.brand_no + ')'">{{item.company}}({{item.brand_no}})</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="码类型" name='code_type'>
        <a-select v-model:value="search.code_type" :style="{width:'130px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option value="1">标准码</a-select-option>
          <a-select-option value="2">2级套标</a-select-option>
          <a-select-option value="3">3级套标</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="码层级" name='code_level'>
        <a-select v-model:value="search.code_level" :style="{width:'120px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option value="big">大标</a-select-option>
          <a-select-option value="middle">中标</a-select-option>
          <a-select-option value="small">小标</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="状态" name='gen_status'>
        <a-select v-model:value="search.gen_status" :style="{width:'120px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option value="0">待生码</a-select-option>
          <a-select-option value="1">生码中</a-select-option>
          <a-select-option value="2">已完成</a-select-option>
          <a-select-option value="4">已失败</a-select-option>
          <a-select-option value="5">已取消</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="关键词" name='keywords'>
        <a-input style="width: 220px" v-model:value="search.keywords" placeholder="批次号、订单号" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='list' class="tableFixBox m-t-20" :scroll="{ x: 'max-content'}">
      <template v-slot:gen_status="{ record }">
        <a-tag :color="statusMap[record.gen_status] && statusMap[record.gen_status].color">{{statusMap[record.gen_status] ? statusMap[record.gen_status].text : '未知'}}</a-tag>
      </template>
      <template v-slot:action="{ record }">
        <a-button v-has:genCodeOrderDetail="()=>showDetail(record)" size="small" type="link">详情</a-button>
        <a-button v-if="record.gen_status == 1" v-has:genCodeOrderProgress="()=>showProgress(record)" size="small" type="link">查看进度</a-button>
        <a-button v-if="record.gen_status == 0 || record.gen_status == 4" v-has:genCodeOrderUpdate="()=>showEdit(record)" size="small" type="link">修改</a-button>
        <a-popconfirm v-if="record.gen_status == 0" title="确定手动触发生码？同品牌同时只允许一个生码中订单" @confirm="doStartOrder(record)">
          <a-button v-has:genCodeOrderStart size="small" type="link">生码</a-button>
        </a-popconfirm>
        <a-popconfirm v-if="record.gen_status == 0" title="确定取消该生码单？" @confirm="doCancelOrder(record)">
          <a-button v-has:genCodeOrderCancel size="small" type="link">取消</a-button>
        </a-popconfirm>
        <a-popconfirm v-if="record.gen_status == 0 || record.gen_status == 4 || record.gen_status == 5" title="确定删除该生码单？删除后不可恢复" @confirm="doDeleteOrder(record)">
          <a-button v-has:genCodeOrderDelete danger size="small" type="link">删除</a-button>
        </a-popconfirm>
        <a-button v-if="record.gen_status == 2" v-has:genCodeOrderExport="()=>showExport(record)" size="small" type="link">导出</a-button>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
  <!-- 创建 / 修改生码单（共用表单，editMode 区分） -->
  <a-modal v-model:visible="createShow" :title="editMode ? '修改生码单' : '创建生码单'" :width="980" centered destroyOnClose :confirm-loading="createLoading" @ok="createSubmit" :bodyStyle="{maxHeight:'85vh',overflowY:'auto',paddingBottom:'8px'}">
    <a-form ref="createForm" class="gen-form" :model="form" :rules="rules" :label-col="{span:5}" :wrapper-col="{span:18}">
      <div class="form-section-title">商户信息</div>
      <a-form-item label="品牌商" name="brand_id">
        <span v-if="editMode">{{editBrandName || form.brand_id}}</span>
        <a-select v-else v-model:value="form.brand_id" show-search option-filter-prop="label" placeholder="请选择品牌商">
          <a-select-option v-for="item in brands" :key="item.brand_no" :value="item.brand_no" :label="item.company + '(' + item.brand_no + ')'">{{item.company}}({{item.brand_no}})</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item v-if="editMode" label="批次号">
        <span style="color:#595959">{{editBatchSn}}</span>
        <span class="form-tip-inline">修改时保留原批次号</span>
      </a-form-item>
      <a-form-item label="备注">
        <a-textarea v-model:value="form.remarks" placeholder="请输入备注" :rows="2" :maxlength="500" />
      </a-form-item>

      <div class="form-section-title">生码配置</div>
      <a-form-item label="码类型" name="ui_type">
        <a-radio-group v-model:value="form.ui_type" button-style="solid">
          <a-radio-button value="small">标准码（小标）</a-radio-button>
          <a-radio-button value="group">套标</a-radio-button>
          <a-radio-button value="big">大标</a-radio-button>
          <a-radio-button value="middle">中标</a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item v-if="form.ui_type == 'group'" label="包装规格">
        <a-select v-model:value="form.packtype" style="width:160px">
          <a-select-option :value="2">两级包装</a-select-option>
          <a-select-option :value="3">三级包装</a-select-option>
        </a-select>
        <div class="ratio-row" style="margin-top:8px">
          <span class="ratio-label">1大标 ×</span>
          <template v-if="form.packtype == 3">
            <a-input-number v-model:value="form.middle_counts" :min="1" :max="1000000" style="width:90px" placeholder="请输入" />
            <span class="ratio-label">中标 ×</span>
          </template>
          <a-input-number v-model:value="form.small_counts" :min="1" :max="1000000" style="width:90px" placeholder="请输入" />
          <span class="ratio-label">小标</span>
        </div>
      </a-form-item>
      <a-form-item label="生码量" name="counts">
        <a-input-number v-model:value="form.counts" :min="1" :max="1000000" style="width:200px" placeholder="请输入" />
        <span v-if="form.ui_type == 'group'" class="ratio-label">套</span>
      </a-form-item>
      <a-form-item v-if="form.ui_type == 'group'" label="总码量（小标）">
        <div class="total-box" :class="{over: totalCodes > 1000000}">
          <span v-if="form.packtype == 2">{{form.counts || 0}} 套 × {{form.small_counts || 0}} =&nbsp;</span>
          <span v-else>{{form.counts || 0}} 套 × {{form.middle_counts || 0}} × {{form.small_counts || 0}} =&nbsp;</span>
          <b>{{totalCodes}}</b>
          <span v-if="totalCodes > 1000000">，超过上限100万</span>
        </div>
      </a-form-item>

      <template v-if="needSecurity">
        <div class="form-section-title">防伪码</div>
        <a-form-item label="类型 / 长度">
          <a-space>
            <a-select v-model:value="form.security_type" style="width:180px">
              <a-select-option v-for="item in securityTypes" :key="item.value" :value="item.value">{{item.label}}</a-select-option>
            </a-select>
            <template v-if="form.security_type != 8">
              <a-input-number v-model:value="form.security_length" :min="12" :max="32" style="width:120px" />
              <span class="form-tip-inline">最低12位；数量与小标总码量一致</span>
            </template>
            <span v-else class="form-tip-inline">固定32位；数量与小标总码量一致</span>
          </a-space>
        </a-form-item>
        <template v-if="form.security_type == 8">
          <a-form-item label=" " :colon="false">
            <div class="agri-desc">
              <p>位数/含义/说明</p>
              <p>第1位 登记类别码：“1”：PD（正式登记），“2”：WP（卫生用农药），“3”：临时登记</p>
              <p>第2-7位 登记证号后6位：不足6位需查询中国农药信息网补齐</p>
              <p>第8位 生产类型码：“1”：持证人自产，“2”：委托加工，“3”：委托分装</p>
              <p>第9-11位 产品规格码：由企业自行编制</p>
              <p>第12-32位 随机码：系统固定生成的21位数字乱码，确保唯一</p>
            </div>
          </a-form-item>
          <a-form-item label="单位识别构成">
            <a-space wrap>
              <a-select v-model:value="form.agri_category" style="width:170px">
                <a-select-option v-for="item in agriCategories" :key="item.value" :value="item.value">{{item.label}}</a-select-option>
              </a-select>
              <a-input v-model:value="form.agri_reg_no" style="width:140px" :maxlength="6" placeholder="登记证号后6位" />
              <a-select v-model:value="form.agri_prod_type" style="width:170px">
                <a-select-option v-for="item in agriProdTypes" :key="item.value" :value="item.value">{{item.label}}</a-select-option>
              </a-select>
              <a-input v-model:value="form.agri_spec" style="width:110px" :maxlength="3" placeholder="产品规格码" />
            </a-space>
          </a-form-item>
          <a-form-item label="自定义前缀">
            <a-radio-group :value="1" disabled>
              <a-radio :value="1">启用</a-radio>
              <a-radio :value="0">禁用</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="前缀内容">
            <a-input :value="agriPrefix" readonly style="width:260px" placeholder="由单位识别构成自动拼接（11位）" />
          </a-form-item>
        </template>
        <a-form-item label="验证码">
          <a-radio-group v-model:value="form.verify_status">
            <a-radio :value="1">启用</a-radio>
            <a-radio :value="0">禁用</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item v-if="form.verify_status == 1" label="验证码类型">
          <a-space>
            <a-select v-model:value="form.verify_type" style="width:140px">
              <a-select-option v-for="item in verifyTypes" :key="item.value" :value="item.value">{{item.label}}</a-select-option>
            </a-select>
            <span class="ratio-label">长度</span>
            <a-input-number v-model:value="form.verify_length" :min="1" :max="10" style="width:90px" placeholder="请输入" />
          </a-space>
        </a-form-item>
      </template>
    </a-form>
  </a-modal>
  <!-- 生码单详情 -->
  <a-modal v-model:visible="detailShow" title="生码单详情" :width="860" :footer="null" centered destroyOnClose>
    <a-spin :spinning="detailLoading">
      <a-descriptions bordered size="small" :column="2">
        <a-descriptions-item label="ID">{{detail.id}}</a-descriptions-item>
        <a-descriptions-item label="品牌商">{{detail.brand_name || detail.brand_id}}</a-descriptions-item>
        <a-descriptions-item label="订单号">{{detail.order_sn}}</a-descriptions-item>
        <a-descriptions-item label="批次号">{{detail.batch_sn}}</a-descriptions-item>
        <a-descriptions-item label="码类型">{{codeTypeText[detail.code_type] || '-'}}</a-descriptions-item>
        <a-descriptions-item label="状态">
          <a-tag :color="statusMap[detail.gen_status] && statusMap[detail.gen_status].color">{{statusMap[detail.gen_status] ? statusMap[detail.gen_status].text : '未知'}}</a-tag>
        </a-descriptions-item>
        <a-descriptions-item :label="detail.code_type == 1 ? '码量' : '套数'">{{detail.counts}}</a-descriptions-item>
        <a-descriptions-item label="包装比例">{{ratioText(detail)}}</a-descriptions-item>
        <a-descriptions-item label="生码层级">{{layerText(detail)}}</a-descriptions-item>
        <a-descriptions-item label="总码量（小标）">{{totalText(detail)}}</a-descriptions-item>
        <a-descriptions-item label="防伪码" :span="2">{{securityText(detail)}}</a-descriptions-item>
        <a-descriptions-item label="小标验证码" :span="2">{{verifyText(detail.verify_status, detail.verify_type, detail.verify_length)}}</a-descriptions-item>
        <a-descriptions-item label="大标序号区间">{{serialText(detail.big_serial_start, detail.big_serial_end, detail.big_code_counts)}}</a-descriptions-item>
        <a-descriptions-item label="中标序号区间">{{serialText(detail.middle_serial_start, detail.middle_serial_end, detail.middle_code_counts)}}</a-descriptions-item>
        <a-descriptions-item label="小标序号区间">{{serialText(detail.small_serial_start, detail.small_serial_end, detail.small_code_counts)}}</a-descriptions-item>
        <a-descriptions-item label="备注">{{detail.remarks || '-'}}</a-descriptions-item>
        <a-descriptions-item label="创建时间">{{detail.created_at}}</a-descriptions-item>
        <a-descriptions-item label="更新时间">{{detail.updated_at}}</a-descriptions-item>
      </a-descriptions>
    </a-spin>
  </a-modal>
  <!-- 导出码包（动态配置链接前缀） -->
  <a-modal v-model:visible="exportShow" title="导出码包" :width="560" centered destroyOnClose :confirm-loading="exportLoading" @ok="exportSubmit">
    <a-form :label-col="{span:7}" :wrapper-col="{span:15}">
      <a-form-item label="批次号">
        <span>{{exportRecord.batch_sn}}</span>
      </a-form-item>
      <a-form-item v-if="exportRecord.big_status == 1" label="大标链接前缀">
        <a-select v-model:value="exportForm.big_url_prefix" placeholder="请选择或留空导出原始码值" allowClear>
          <a-select-option value="">无</a-select-option>
          <a-select-option value="https://b.hbgdyh.com/">https://b.hbgdyh.com/</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item v-if="exportRecord.middle_status == 1" label="中标链接前缀">
        <a-select v-model:value="exportForm.middle_url_prefix" placeholder="请选择或留空导出原始码值" allowClear>
          <a-select-option value="">无</a-select-option>
          <a-select-option value="https://m.hbgdyh.com/">https://m.hbgdyh.com/</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item v-if="exportRecord.small_status == 1" label="小标链接前缀">
        <a-select v-model:value="exportForm.small_url_prefix" placeholder="请选择或留空导出原始码值" allowClear>
          <a-select-option value="">无</a-select-option>
          <a-select-option value="https://s.hbgdyh.com/">https://s.hbgdyh.com/</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item v-if="exportRecord.security_status == 1" label="防伪码链接前缀">
        <a-select v-model:value="exportForm.security_url_prefix" placeholder="请选择或留空导出原始码值" allowClear>
          <a-select-option value="">无</a-select-option>
          <a-select-option value="https://c.hbgdyh.com/">https://c.hbgdyh.com/</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label=" " :colon="false">
        <span style="color:#999">支持占位符：{batch_sn}=批次号，{code}=码值；留空导出原始码值</span>
      </a-form-item>
    </a-form>
  </a-modal>
  <!-- 下载弹窗 -->
  <a-modal v-model:visible="downloadShow" title="下载导出文件" :width="480" centered :footer="null">
    <div style="text-align:center;padding:20px 0">
      <a-result status="success" title="导出成功" :sub-title="`共 ${downloadData.line_count} 条，文件名：${downloadData.filename}`">
        <template #extra>
          <a-button type="primary" @click="doDownload" :loading="downloadLoading">下载文件</a-button>
          <a-button @click="downloadShow = false" style="margin-left:8px">关闭</a-button>
        </template>
      </a-result>
      <p style="color:#999;font-size:12px;margin-top:16px">下载链接 5 分钟内有效，过期需重新导出</p>
    </div>
  </a-modal>
  <!-- 生码进度 -->
  <a-modal v-model:visible="progressShow" title="生码进度" :width="480" :footer="null" centered destroyOnClose>
    <div style="text-align:center;padding:20px 0">
      <a-progress :percent="progressPercent" :status="progressData.gen_status == 4 ? 'exception' : (progressData.gen_status == 2 ? 'success' : 'active')" />
      <p class="m-t-10">批次号：{{progressData.batch_sn}}</p>
      <p>状态：{{statusMap[progressData.gen_status] ? statusMap[progressData.gen_status].text : '查询中...'}}</p>
      <p v-if="progressData.gen_status == 1">已生成：{{progressData.generated_count || 0}} 条（每3秒自动刷新）</p>
    </div>
  </a-modal>
</template>
<script>
import useTableSearch from "@/hooks/useTableSearch";
import { computed, h, onMounted, onUnmounted, reactive, ref, watch } from "vue";
import { getGenOrderList, createGenOrder, updateGenOrder, deleteGenOrder, startGenOrder, cancelGenOrder, getGenOrderDetail, retryGenOrder, exportGenOrder, downloadExportFile, getGenOrderProgress } from "@/api/codeGen";
import { getBrandtList } from "@/api/brand";
import { message } from "ant-design-vue";
import { $iscode } from "@/utils/app";
import { PlusOutlined } from "@ant-design/icons-vue";
import config from "@/config";

const baseUrl = config.baseUrl[process.env.VUE_APP_type];
const defSearch = {
  brand_id: undefined,
  code_type: "",
  code_level: "",
  gen_status: "",
  keywords: "",
  page: 1,
  limit: 10,
};
const defForm = {
  brand_id: undefined,
  ui_type: "small",
  packtype: 2,
  counts: 1,
  middle_counts: 1,
  small_counts: 1,
  security_type: 3,
  security_length: 12,
  agri_category: 1,
  agri_reg_no: "",
  agri_prod_type: 1,
  agri_spec: "",
  verify_status: 0,
  verify_type: 1,
  verify_length: 4,
  remarks: "",
};
const defExportForm = {
  big_url_prefix: "",
  middle_url_prefix: "",
  small_url_prefix: "",
  security_url_prefix: "https://c.hbgdyh.com/",
};
export default {
  components: { PlusOutlined },
  setup() {
    const statusMap = {
      0: { text: "待生码", color: "orange" },
      1: { text: "生码中", color: "blue" },
      2: { text: "已完成", color: "green" },
      4: { text: "已失败", color: "red" },
      5: { text: "已取消", color: "default" },
    };
    const codeTypeText = { 1: "标准码", 2: "2级套标", 3: "3级套标" };
    const verifyTypes = [
      { value: 1, label: "数字乱码" },
    ];
    // 防伪码类型
    const securityTypes = [
      { value: 1, label: "数字乱码" },
      { value: 3, label: "数字小写字母乱码" },
      { value: 5, label: "小写字母乱码" },
      { value: 8, label: "农业部32位" },
    ];
    const securityTypeText = { 1: "数字乱码", 3: "数字小写字母乱码", 5: "小写字母乱码", 8: "农业部32位" };
    // 农业部32位：单位识别构成选项
    const agriCategories = [
      { value: 1, label: "1: PD（正式登记）" },
      { value: 2, label: "2: WP（卫生用农药）" },
      { value: 3, label: "3: 临时登记" },
    ];
    const agriProdTypes = [
      { value: 1, label: "1: 持证人自产" },
      { value: 2, label: "2: 委托加工" },
      { value: 3, label: "3: 委托分装" },
    ];
    const layerText = (row) => {
      let arr = [];
      if (row.big_status == 1) arr.push("大标");
      if (row.middle_status == 1) arr.push("中标");
      if (row.small_status == 1) arr.push("小标");
      return arr.length ? arr.join("+") : "-";
    };
    const ratioText = (row) => {
      if (row.code_type == 2) return `1×${row.small_counts}`;
      if (row.code_type == 3) return `1×${row.middle_counts}×${row.small_counts}`;
      return "-";
    };
    const totalText = (row) => {
      if (row.code_type == 2) return row.counts * row.small_counts;
      if (row.code_type == 3) return row.counts * row.middle_counts * row.small_counts;
      return row.small_status == 1 ? row.counts : "-";
    };
    const verifyText = (status, type, length) => {
      if (status != 1) return "未启用";
      let item = verifyTypes.find((v) => v.value == type);
      return (item ? item.label : type) + " / " + length + "位";
    };
    const serialText = (start, end, counts) => {
      if (!start && !end) return "-";
      return `${start || "-"} ~ ${end || "-"}（${counts || 0}条）`;
    };
    let columns = [
      {
        title: "ID",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "订单号",
        dataIndex: "order_sn",
        key: "order_sn",
      },
      {
        title: "批次号",
        dataIndex: "batch_sn",
        key: "batch_sn",
      },
      {
        title: "品牌商",
        dataIndex: "brand_name",
        key: "brand_name",
      },
      {
        title: "码类型",
        dataIndex: "code_type",
        key: "code_type",
        customRender: function ({ record }) {
          return codeTypeText[record.code_type] || "-";
        },
      },
      {
        title: "生码层级",
        key: "layers",
        customRender: function ({ record }) {
          return layerText(record);
        },
      },
      {
        title: "码量",
        dataIndex: "counts",
        key: "counts",
        customRender: function ({ record }) {
          if (record.code_type == 2) return `${record.counts}套×${record.small_counts}=${record.counts * record.small_counts}`;
          if (record.code_type == 3) return `${record.counts}套×${record.middle_counts}×${record.small_counts}=${record.counts * record.middle_counts * record.small_counts}`;
          return record.counts;
        },
      },
      {
        title: "序号区间",
        key: "serial_range",
        width: 280,
        customRender: function ({ record }) {
          const parts = [];
          if (record.big_status == 1 && record.big_serial_start && record.big_serial_end) {
            parts.push(h('span', { style: { color: '#f5222d', fontWeight: 'bold' } }, `大:${record.big_serial_start}-${record.big_serial_end}`));
          }
          if (record.middle_status == 1 && record.middle_serial_start && record.middle_serial_end) {
            parts.push(h('span', { style: { color: '#f5222d', fontWeight: 'bold' } }, `中:${record.middle_serial_start}-${record.middle_serial_end}`));
          }
          if (record.small_status == 1 && record.small_serial_start && record.small_serial_end) {
            parts.push(h('span', { style: { color: '#f5222d', fontWeight: 'bold' } }, `小:${record.small_serial_start}-${record.small_serial_end}`));
          }
          if (parts.length === 0) return '-';
          return h('div', null, parts.map((p, i) => h('div', { key: i, style: { lineHeight: '20px' } }, p)));
        },
      },
      {
        title: "状态",
        dataIndex: "gen_status",
        key: "gen_status",
        slots: { customRender: "gen_status" },
      },
      {
        title: "创建时间",
        dataIndex: "created_at",
        key: "created_at",
      },
      {
        title: "操作",
        key: "action",
        fixed: "right",
        slots: { customRender: "action" },
      },
    ];
    const {
      pageCurrentChange,
      pageSizeChange,
      search,
      list,
      initData,
      total,
      pageSearchChange,
      listLoading,
    } = useTableSearch({ data: { ...defSearch } });
    const tableHooks = {
      pageCurrentChange,
      pageSizeChange,
      search,
      initData,
      list,
      total,
      pageSearchChange,
      listLoading,
    };
    // 品牌商下拉
    const brands = ref([]);
    const initBrands = async () => {
      let res = await getBrandtList({ page: 1, limit: 1000 }).then((res) => res.data).catch((error) => error);
      if ($iscode(res)) {
        brands.value = res.data.data || [];
      }
    };
    onMounted(() => {
      tableHooks.initData(getGenOrderList);
      initBrands();
    });
    // 创建生码单
    const createShow = ref(false);
    const createLoading = ref(false);
    const createForm = ref();
    const form = reactive({ ...defForm });
    const rules = {
      brand_id: [{ required: true, type: "any", message: "请选择品牌商" }],
      counts: [{ required: true, type: "number", message: "请输入生码量" }],
    };
    // 切换码类型时重置包装规格，避免残留值带入提交
    watch(() => form.ui_type, () => {
      form.packtype = 2;
      form.middle_counts = 1;
      form.small_counts = 1;
    });
    // 含小标层级（标准码小标/套标）才有防伪码与验证码
    const needSecurity = computed(() => form.ui_type == "small" || form.ui_type == "group");
    // 农业部32位：前缀内容由4个构成项自动拼接（1+6+1+3）
    const agriPrefix = computed(() => String(form.agri_category) + String(form.agri_reg_no || "") + String(form.agri_prod_type) + String(form.agri_spec || ""));
    // 纯数字输入约束：登记证号后6位 / 产品规格码
    watch(() => form.agri_reg_no, (v) => {
      const cleaned = String(v || "").replace(/\D/g, "").slice(0, 6);
      if (cleaned !== v) form.agri_reg_no = cleaned;
    });
    watch(() => form.agri_spec, (v) => {
      const cleaned = String(v || "").replace(/\D/g, "").slice(0, 3);
      if (cleaned !== v) form.agri_spec = cleaned;
    });
    const securityText = (row) => {
      if (row.security_status != 1) return "未启用";
      let text = `${securityTypeText[row.security_type] || row.security_type} / ${row.security_length}位 / 数量${row.security_code_counts}`;
      if (row.security_type == 8) text += ` / 前缀${row.security_prefix_value || "-"}`;
      return text;
    };
    // 小标总码量
    const totalCodes = computed(() => {
      if (form.ui_type != "group") return form.counts || 0;
      if (form.packtype == 3) return (form.counts || 0) * (form.middle_counts || 0) * (form.small_counts || 0);
      return (form.counts || 0) * (form.small_counts || 0);
    });
    // 创建/修改 共用状态
    const editMode = ref(false);
    const editId = ref(0);
    const editBatchSn = ref("");
    const editBrandName = ref("");
    const showCreate = () => {
      editMode.value = false;
      editId.value = 0;
      editBatchSn.value = "";
      Object.assign(form, { ...defForm });
      createShow.value = true;
    };
    const showEdit = (record) => {
      editMode.value = true;
      editId.value = record.id;
      editBatchSn.value = record.batch_sn || "";
      editBrandName.value = record.brand_name || "";
      // 后端存储字段 → 前端表单字段反向映射
      // 注意：后端返回的数值字段可能是字符串，必须强转数字，否则 a-select/a-radio 严格相等匹配不上
      Object.assign(form, { ...defForm });
      form.brand_id = record.brand_id;
      form.remarks = record.remarks || "";
      form.counts = Number(record.counts) || 1;
      if (record.code_type == 2) {
        form.ui_type = "group";
        form.packtype = 2;
        form.small_counts = Number(record.small_counts) || 1;
      } else if (record.code_type == 3) {
        form.ui_type = "group";
        form.packtype = 3;
        form.middle_counts = Number(record.middle_counts) || 1;
        form.small_counts = Number(record.small_counts) || 1;
      } else {
        // 标准码：根据层级状态反推 ui_type
        if (record.big_status == 1) form.ui_type = "big";
        else if (record.middle_status == 1) form.ui_type = "middle";
        else form.ui_type = "small";
      }
      if (record.security_status == 1) {
        form.security_type = Number(record.security_type) || 3;
        form.security_length = Number(record.security_length) || 12;
        if (form.security_type == 8) {
          // 农业部32位：11位前缀按 1/6/1/3 拆分回显4个构成项
          const prefix = String(record.security_prefix_value || "");
          if (/^\d{11}$/.test(prefix)) {
            form.agri_category = Number(prefix.substr(0, 1)) || 1;
            form.agri_reg_no = prefix.substr(1, 6);
            form.agri_prod_type = Number(prefix.substr(7, 1)) || 1;
            form.agri_spec = prefix.substr(8, 3);
          }
        }
      }
      form.verify_status = Number(record.verify_status) || 0;
      form.verify_type = Number(record.verify_type) || 1;
      form.verify_length = Number(record.verify_length) || 4;
      createShow.value = true;
    };
    // 表单校验 + 数据组装（创建/修改共用）
    const buildSubmitData = () => {
      let data = {
        brand_id: form.brand_id,
        counts: form.counts,
        remarks: form.remarks,
      };
      if (form.ui_type == "group") {
        data.code_type = form.packtype == 3 ? 3 : 2;
        data.small_counts = form.small_counts;
        data.big_status = 1;
        data.middle_status = form.packtype == 3 ? 1 : 0;
        data.small_status = 1;
        if (form.packtype == 3) data.middle_counts = form.middle_counts;
      } else {
        data.code_type = 1;
        data.big_status = form.ui_type == "big" ? 1 : 0;
        data.middle_status = form.ui_type == "middle" ? 1 : 0;
        data.small_status = form.ui_type == "small" ? 1 : 0;
      }
      if (needSecurity.value) {
        data.security_status = 1;
        data.security_type = form.security_type;
        if (form.security_type == 8) {
          // 农业部32位：长度固定32，前缀为11位单位识别构成
          data.security_length = 32;
          data.security_prefix_status = 1;
          data.security_prefix_value = agriPrefix.value;
        } else {
          data.security_length = form.security_length;
        }
      } else {
        data.security_status = 0;
      }
      if (needSecurity.value && form.verify_status == 1) {
        data.verify_status = 1;
        data.verify_type = form.verify_type;
        data.verify_length = form.verify_length;
      } else {
        data.verify_status = 0;
      }
      return data;
    };
    const validateForm = () => {
      if (form.ui_type == "group") {
        if (form.packtype == 2 && !(form.small_counts > 0)) {
          message.error("请填写包装规格：每套小标数");
          return false;
        }
        if (form.packtype == 3 && (!(form.middle_counts > 0) || !(form.small_counts > 0))) {
          message.error("请填写包装规格：每套中标数与每中标小标数");
          return false;
        }
        if (totalCodes.value > 1000000) {
          message.error("总码量超过上限100万");
          return false;
        }
      }
      if (needSecurity.value) {
        if (form.security_type == 8) {
          if (!/^\d{6}$/.test(form.agri_reg_no || "")) {
            message.error("登记证号后6位须为6位纯数字");
            return false;
          }
          if (!/^\d{3}$/.test(form.agri_spec || "")) {
            message.error("产品规格码须为3位纯数字");
            return false;
          }
        } else if (!(form.security_length >= 12 && form.security_length <= 32)) {
          message.error("防伪码长度须在12~32位之间");
          return false;
        }
      }
      return true;
    };
    const createSubmit = async () => {
      try {
        await createForm.value.validate();
      } catch (e) {
        return;
      }
      if (!validateForm()) return;
      const data = buildSubmitData();
      const hide = message.loading(editMode.value ? "正在修改..." : "正在提交...", 0);
      createLoading.value = true;
      const apiCall = editMode.value
        ? updateGenOrder(editId.value, data)
        : createGenOrder(data);
      let res = await apiCall.then((res) => res.data).catch((error) => error);
      createLoading.value = false;
      setTimeout(hide, 100);
      if ($iscode(res, true)) {
        createShow.value = false;
        message.success(editMode.value ? "修改成功" : "创建成功");
        tableHooks.initData(getGenOrderList);
      }
    };
    // 删除生码单
    const doDeleteOrder = async (record) => {
      const hide = message.loading("正在删除...", 0);
      let res = await deleteGenOrder(record.id).then((res) => res.data).catch((error) => error);
      setTimeout(hide, 100);
      if ($iscode(res, true)) {
        message.success("删除成功");
        tableHooks.initData(getGenOrderList);
      }
    };
    // 手动触发生码
    const doStartOrder = async (record) => {
      const hide = message.loading("正在派发生码任务...", 0);
      let res = await startGenOrder(record.id).then((res) => res.data).catch((error) => error);
      setTimeout(hide, 100);
      if ($iscode(res, true)) {
        message.success("已派发生码任务");
        tableHooks.initData(getGenOrderList);
      }
    };
    // 取消生码单
    const doCancelOrder = async (record) => {
      const hide = message.loading("正在取消...", 0);
      let res = await cancelGenOrder(record.id).then((res) => res.data).catch((error) => error);
      setTimeout(hide, 100);
      if ($iscode(res, true)) {
        message.success("已取消");
        tableHooks.initData(getGenOrderList);
      }
    };
    // 详情
    const detailShow = ref(false);
    const detailLoading = ref(false);
    const detail = ref({});
    const showDetail = async (record) => {
      detail.value = {};
      detailShow.value = true;
      detailLoading.value = true;
      let res = await getGenOrderDetail(record.id).then((res) => res.data).catch((error) => error);
      detailLoading.value = false;
      if ($iscode(res)) {
        detail.value = res.data;
      } else {
        message.error(res.msg);
      }
    };
    // 重试
    const retryOrder = async (record) => {
      const hide = message.loading("正在提交...", 0);
      let res = await retryGenOrder(record.id).then((res) => res.data).catch((error) => error);
      setTimeout(hide, 100);
      if ($iscode(res, true)) {
        tableHooks.initData(getGenOrderList);
      }
    };
    // 导出（弹窗动态配置链接前缀）
    const exportShow = ref(false);
    const exportLoading = ref(false);
    const exportRecord = ref({});
    const exportForm = reactive({ ...defExportForm });
    const showExport = (record) => {
      exportRecord.value = record;
      Object.assign(exportForm, { ...defExportForm });
      exportShow.value = true;
    };
    const exportSubmit = async () => {
      const params = {};
      Object.keys(defExportForm).forEach((key) => {
        const val = String(exportForm[key] || "").trim();
        if (val) params[key] = val;
      });
      const hide = message.loading("正在生成码包...", 0);
      exportLoading.value = true;
      let res = await exportGenOrder(exportRecord.value.id, params).then((res) => res.data).catch((error) => error);
      exportLoading.value = false;
      setTimeout(hide, 100);
      console.log('Export response:', res); // 调试日志
      if ($iscode(res)) {
        console.log('Export data:', res.data); // 调试日志
        // 显示下载弹窗（res 是 axios 响应的 data，包含 code/msg/data）
        downloadData.value = {
          token: res.data.token,
          filename: res.data.filename,
          line_count: res.data.line_count,
        };
        console.log('Download data:', downloadData.value); // 调试日志
        exportShow.value = false;
        downloadShow.value = true;
      } else {
        message.error(res.msg);
      }
    };
    // 下载相关
    const downloadShow = ref(false);
    const downloadLoading = ref(false);
    const downloadData = ref({ token: "", filename: "", line_count: 0 });
    const doDownload = async () => {
      if (!downloadData.value.token) {
        message.error("下载令牌无效");
        return;
      }
      downloadLoading.value = true;
      try {
        let res = await downloadExportFile(downloadData.value.token);
        // 创建 blob 下载
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", downloadData.value.filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        downloadShow.value = false;
        message.success("下载成功");
      } catch (error) {
        message.error("下载失败：" + (error.message || "未知错误"));
      } finally {
        downloadLoading.value = false;
      }
    };
    // 进度轮询
    const progressShow = ref(false);
    const progressData = ref({});
    let progressTimer = null;
    const progressPercent = computed(() => {
      if (progressData.value.gen_status == 2) return 100;
      return Number(progressData.value.progress_percent || 0);
    });
    const stopProgress = () => {
      if (progressTimer) {
        clearInterval(progressTimer);
        progressTimer = null;
      }
    };
    const fetchProgress = async (id) => {
      let res = await getGenOrderProgress(id).then((res) => res.data).catch((error) => error);
      if ($iscode(res)) {
        progressData.value = res.data;
        // 非生成中状态停止轮询并刷新列表
        if (res.data.gen_status != 1) {
          stopProgress();
          if (res.data.gen_status == 2) message.success("生码完成");
          if (res.data.gen_status == 4) message.error("生码失败");
          tableHooks.initData(getGenOrderList);
        }
      }
    };
    const showProgress = (record) => {
      stopProgress();
      progressData.value = {};
      progressShow.value = true;
      fetchProgress(record.id);
      progressTimer = setInterval(() => {
        fetchProgress(record.id);
      }, 3000);
    };
    watch(progressShow, (val) => {
      if (!val) stopProgress();
    });
    onUnmounted(() => {
      stopProgress();
    });
    return {
      ...tableHooks,
      columns,
      statusMap,
      codeTypeText,
      verifyTypes,
      securityTypes,
      securityTypeText,
      agriCategories,
      agriProdTypes,
      agriPrefix,
      securityText,
      brands,
      layerText,
      ratioText,
      totalText,
      verifyText,
      serialText,
      createShow,
      createLoading,
      createForm,
      form,
      rules,
      needSecurity,
      totalCodes,
      editMode,
      editBatchSn,
      editBrandName,
      showCreate,
      showEdit,
      createSubmit,
      doDeleteOrder,
      doStartOrder,
      doCancelOrder,
      detailShow,
      detailLoading,
      detail,
      showDetail,
      retryOrder,
      exportShow,
      exportLoading,
      exportRecord,
      exportForm,
      showExport,
      exportSubmit,
      downloadShow,
      downloadLoading,
      downloadData,
      doDownload,
      progressShow,
      progressData,
      progressPercent,
      showProgress,
    };
  },
};
</script>
<style scoped>
/* 创建生码单表单分区与紧凑化 */
.gen-form :deep(.ant-form-item) {
  margin-bottom: 14px;
}
.form-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #262626;
  padding-bottom: 8px;
  margin: 4px 0 16px;
  border-bottom: 1px solid #f0f0f0;
}
.form-tip {
  color: #999;
  font-size: 12px;
  line-height: 20px;
  margin-top: 4px;
}
.form-tip-inline {
  color: #999;
  font-size: 12px;
  margin-left: 8px;
}
.agri-desc {
  width: 100%;
  background: #f5f5f5;
  border-left: 3px solid #13c2c2;
  padding: 8px 14px;
  color: #595959;
  font-size: 12px;
  line-height: 22px;
}
.agri-desc p {
  margin: 0;
}
.ratio-row {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.ratio-label {
  color: #595959;
  margin: 0 6px;
}
.total-box {
  display: inline-block;
  background: #f0f7ff;
  border: 1px solid #d6e4ff;
  border-radius: 4px;
  padding: 4px 14px;
  color: #595959;
}
.total-box b {
  font-size: 16px;
  color: #1890ff;
}
.total-box.over {
  background: #fff1f0;
  border-color: #ffa39e;
  color: #f5222d;
}
.total-box.over b {
  color: #f5222d;
}
</style>
